import RequestAbstract from "../abstract";

export default class PublicAppeals extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = 'api/public-appeals';
    }
    updateStatus = async (id, status) => {
        return this.loadWithAuth(`${this.link}/set/${id}/status/${status}`, {
            method: 'GET'
        });
    };
}
